import React from 'react';
import { Wrapper } from '../Wrapper';
import {
    BannerProps as RawBannerProps,
    Banner as RawBanner,
} from '../../../components/landingPage/Banner';
import { Image, ImageProps } from '../Image';
import { SanityObject } from '../../../lib/landingPage';

type BannerProps = Omit<RawBannerProps, 'image'> & {
    imageRef: SanityObject<ImageProps>;
};

export const Banner = Wrapper((props: BannerProps): JSX.Element | null => {
    return (
        <RawBanner
            {...props}
            image={<Image value={props.imageRef} dataset="blog" />}
        />
    );
}, 'banner');
